var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "wall_art_16dp_000000_FILL0_wght400_GRAD0_opsz20") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WordPress-Global-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(-478.000000, -591.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wall_art_16dp_000000_FILL0_wght400_GRAD0_opsz20",
    transform: "translate(478.000000, 591.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5,16 C1.0875,16 0.734375,15.8530556 0.440625,15.5591667 C0.146875,15.2652778 0,14.9119444 0,14.4991667 L0,5.49416667 C0,5.08138889 0.146875,4.72916667 0.440625,4.4375 C0.734375,4.14583333 1.0875,4 1.5,4 L4,4 L8,0 L12,4 L14.5,4 C14.9125,4 15.265625,4.14694444 15.559375,4.44083333 C15.853125,4.73472222 16,5.08805556 16,5.50083333 L16,14.5058333 C16,14.9186111 15.853125,15.2708333 15.559375,15.5625 C15.265625,15.8541667 14.9125,16 14.5,16 L1.5,16 Z M1.5,14.5 L14.5,14.5 L14.5,5.5 L1.5,5.5 L1.5,14.5 Z M3.5,13 L12.5,13 L9.5,9 L7.25,12 L5.75,10 L3.5,13 Z M13.1354167,8.63541667 C13.3784722,8.39236111 13.5,8.09722222 13.5,7.75 C13.5,7.40277778 13.3784722,7.10763889 13.1354167,6.86458333 C12.8923611,6.62152778 12.5972222,6.5 12.25,6.5 C11.9027778,6.5 11.6076389,6.62152778 11.3645833,6.86458333 C11.1215278,7.10763889 11,7.40277778 11,7.75 C11,8.09722222 11.1215278,8.39236111 11.3645833,8.63541667 C11.6076389,8.87847222 11.9027778,9 12.25,9 C12.5972222,9 12.8923611,8.87847222 13.1354167,8.63541667 Z M5.41666667,4 L10.5833333,4 L8,1.41666667 L5.41666667,4 Z M1.53958333,14.5 L1.53958333,5.5 L1.53958333,14.5 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArt);
export default __webpack_public_path__ + "static/media/art.f7eb0a74c1f82dc96e4cec2d7afcb000.svg";
export { ForwardRef as ReactComponent };